import type { GQL_ID, CommonSort } from '@@partner:types:graphql'
import type { ProductGroup } from '@@partner:types:app'
import type { ResponsiveTableColumn } from '@components/common/ResponsiveTable/ResponsiveTable'

import React from 'react'
import { Button } from 'rsuite'
import { Link } from 'react-router-dom'
import ResponsiveTable from '@components/common/ResponsiveTable/ResponsiveTable'

import { SORT_ORDER_DESC } from '@@partner:config/graphql'

export interface ProductGroupsTableProps {
  productGroups: ProductGroup[]
  loading: boolean
  tableSort: CommonSort
  onSortColumn?: (dataKey: string, sortType?: 'asc' | 'desc') => void
  generateEditUrl: (productGroupId: GQL_ID) => string
}

export default function ProductGroupsTable ({
  productGroups = [],
  loading = true,
  tableSort,
  onSortColumn,
  generateEditUrl
}: ProductGroupsTableProps) {
  const columns: ResponsiveTableColumn<ProductGroup>[] = [
    {
      dataKey: 'id',
      header: 'ИД',
      sortable: true,
      flexGrow: 1,
      isCardBadge: true
    },
    {
      dataKey: 'name',
      header: 'Название',
      sortable: true,
      flexGrow: 2,
      isCardTitle: true
    },
    {
      dataKey: 'label',
      header: 'Лейбл',
      sortable: true,
      flexGrow: 2
    },
    {
      dataKey: 'type',
      header: 'Тип',
      sortable: true,
      flexGrow: 2
    }
  ]

  const renderActions = (group: ProductGroup) => (
    <Button
      color="cyan"
      as={Link}
      to={generateEditUrl?.(group.id)}
      size="xs"
    >
      Изменить
    </Button>
  )

  return (
    <ResponsiveTable<ProductGroup>
      data={productGroups}
      columns={columns}
      loading={loading}
      sortColumn={tableSort.fieldName}
      sortType={tableSort.direction === SORT_ORDER_DESC ? 'desc' : 'asc'}
      onSortColumn={onSortColumn}
      renderActions={renderActions}
      emptyMessage="Нет групп товаров"
    />
  )
}
